// Mounts the shared job registry's cross-navigation polling and terminal
// invalidation (jobRegistry.ts) at app root, per design §5: "It lives above
// individual rows/tools dialogs so closing a surface or navigating among
// Transactions, Accounts, Business, and Ask does not lose tracking." Mounted
// once in `src/app/App.tsx` -- the only provider this lane adds.
import type { ReactNode } from 'react';
import { useJobRegistryUserSync, useJobWatcher, useTrackedJobIds } from './jobRegistry';

function JobWatcherMount({ jobId }: { jobId: string }) {
  useJobWatcher(jobId);
  return null;
}

export function JobRegistryProvider({ children }: { children: ReactNode }) {
  useJobRegistryUserSync();
  const ids = useTrackedJobIds();
  return (
    <>
      {ids.map((id) => (
        <JobWatcherMount key={id} jobId={id} />
      ))}
      {children}
    </>
  );
}

export default JobRegistryProvider;
